// 奖品类型
const prizeTypeList = [
  { value: 1, label: '优惠券' },
  { value: 3, label: '实物(手工发放)' },
  { value: 4, label: '积分' },
  { value: 5, label: '实物(随单发)' },
  { value: 6, label: '实物(专属下单)' },
  { value: 7, label: '礼品卡' },
	{ value: 8, label: '组合奖品' },
	{ value: 9, label: '谢谢参与' },
];

// 活动类型
const globalActivityList = [
  { label: "全部", value: "" },
  { label: "下单有礼", value: 16 },
  { label: "0元试用", value: 33 },
  { label: "打榜有礼", value: 36 },
  { label: "邀请有礼", value: 37 },
  { label: "幸运抽奖", value: 38 },
  { label: "积分锁权", value: 39 },
  { label: "生日有礼", value: 40 },
  { label: "晒单有礼", value: 41 },
  { label: "会员升级礼", value: 42 },
  { label: "购物打卡", value: 43 },
  { label: "问卷调查", value: 44 },
  { label: "定时开奖", value: 45 },
  { label: "情书贺卡", value: 46 },
  { label: "日历打卡", value: 47 },
  { label: "试用回购礼", value: 48 },
  { label: "生日有礼（定制）", value: 49 },
	{ label: "会员升级礼（定制）", value: 50 },
  { label: "集卡有礼", value: 51 },
  { label: "粉丝打卡", value: 52 },
  { label: "组队瓜分奖品", value: 53 },
  { label: "入会有礼", value: 54 },
  { label: "会员成长计划", value: 55 },
  { label: "拼团砍价", value: 56 },
  { label: "趣味游戏", value: 58 },
  { label: "时光许愿池", value: 59 },
  { label: "直播间抽奖", value: 60 },
  { label: "购物车锦鲤", value: 61 },
  { label: "王牌对对碰", value: 64 },
  { label: "答题导购", value: 63 },
  { label: "满额有礼", value: 65 },
  { label: "集分冲榜", value: 66 },
  { label: "粉丝集分应援", value: 67 },
]

/***
 * 公用常量配置
 */
export default {
  install(Vue) {
    //会员等级
    Vue.prototype.memberUser_all = [
      {
        value: "0",
        label: '店铺会员'
      },
      {
        value: "1",
        label: '普通会员'
      },
      {
        value: "2",
        label: '高级会员'
      },
      {
        value: "3",
        label: 'VIP会员'
      },
      {
        value: "4",
        label: '至尊VIP会员'
      }
    ];
    //性别
    Vue.prototype.sex_all = [
      {
        value: '0',
        label: '未知'
      },
      {
        value: '1',
        label: '男'
      },
      {
        value: '2',
        label: '女'
      },
    ];
    //全局引用，并且或者
    Vue.prototype.sureOr_all = [
      {
        id: 0,
        label: '并且'
      },
      {
        id: 1,
        label: '或者'
      }
    ];
    //职业
    Vue.prototype.worker_all = [
      {
        value: '1',
        label: '学生'
      },
      {
        value: '2',
        label: '白领'
      },
      {
        value: '3',
        label: '公务员'
      }
      ,
      {
        value: '4',
        label: 'IT'
      }
      ,
      {
        value: '5',
        label: '金融族'
      },
      {
        value: '6',
        label: '居家族'
      },
      {
        value: '7',
        label: '医护人员'
      },
      {
        value: '8',
        label: '其他'
      }
    ];

    // type: 1：传值 0：传input实例
    // e: 值或者input实例
    // decimal: 1表示允许小数点 0表示整数, 
    // min：允许传入最小值，小于这个值时返回""
    Vue.prototype.getNumberData = function (type, e, decimal = 0, min = 1, max = -1) {
      let str = ""
      if (type) {
        str = String(e)
      } else {
        str = String(e.target.value)
      }

      let num = decimal ? str.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".").replace(/[^\d.]/g, "") : str.replace(/[^\d]/g, '')
      if (num < min) {
        num = "";
      }
      if (max != -1 && max < num) {
        num = max;
      }
      return num
    };
    Vue.prototype.goToGuide = function () {
      let textUrl = "https://www.yuque.com/yunduanxincrm/dyyz/gotgdiqoy9ve8lcg"
      window.open(textUrl, "_blank");
    };
    Vue.prototype.goToAuthorGuide = function () {
      let textUrl = "https://www.yuque.com/yunduanxincrm/dyyz/mya52cu3ibno9vz3?singleDoc#"
      window.open(textUrl, "_blank");
    };
    // 限制输入数字可选保留两位小数限制最大值
    Vue.prototype.getLimit = function (str, type, maxNum, minNum = 0, hasMax = true) {
      if (str[0] == ".") {
        str = ""
      }
      if (str[0] == '0' && str.length > 1 && str.indexOf(".") == -1) {
        str = '0'
      }
      str = type == 1 ? str.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".").replace(/([0-9]+\.[0-9]{2})[0-9]*/, '$1').replace(/[^\d.]/g, "") : str.replace(/[^\d]/g, "")
      if (Number(str) > maxNum && hasMax) {
        str = maxNum + ''
      }
      if (Number(str) < minNum) {
        str = ''
      }
      return str;
    }
    // 处理互动活动保存草稿处理未填项
    Vue.prototype.getHasInputValue = function (obj) {
      for (let key in obj) {
        if (!obj[key] && obj[key] != 0) {
          delete obj[key]
        }
      }
      return obj
    }
    // 直播房间ID过滤
    Vue.prototype.$filterLiveStreamID = function (id) {
      return id.replace(/[^\d,]/g, '')
        .replace(/,+/g, ',')
        .replace(/^,$/g, '');
    }
    // 活动类型
		Vue.prototype.globalActivityList = globalActivityList
		// 根据活动类型获取活动类型名称
		Vue.prototype.$getActivityNameByValue = (value)=>{
      const allType = [
				...globalActivityList,
				{ label: "积分兑换", value: 9 },
				{ label: "积分竞拍", value: 57 },
			]
			const index = allType.findIndex(item=>item.value == value)
			if(index != -1){
				return allType[index].label
			}else{
				return ''
			}
		}

    // 添加奖品类型列表
    Vue.prototype.prizeTypeList = prizeTypeList;
    // 添加奖品类型判断方法
    Vue.prototype.$getPrizeTypeName = (value) => {
      const type = prizeTypeList.find(item => item.value == value);
      return type ? type.label : '';
    };
    // type: 1表示允许小数点 0表示整数, min表示 低于min过滤掉
		Vue.prototype.hd_getNumberData = function (e, type, min = 1, max = 99999999) {
      const str = String(e)
      let num = type ? str.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".").replace(/[^\d.]/g, "") : str.replace(/[^\d]/g, '')
      if (num < min && min) {
        num = "";
      }
      if (num > max) {
        num = max
      }
      return num
		}
    // 统一处理奖品参数
		Vue.prototype.$dealPrizeObj = function (obj, data, prizeType) {
			if (prizeType == 3) {
				obj.shouldCollectExtraData = data.shouldCollectExtraData;
        obj.shouldModifyAddress = data.shouldModifyAddress;
				if (data.questionId) {
					obj.questionId = data.questionId;
				}
				if (data.shouldCollectExtraData) {
					obj.questionInfo = data.questionInfo;
				}
			}
			return obj;
		}
    // 进心中任务支持修改
		Vue.prototype.$isSupportTask = function (row, isStart) {
			// 加入群聊支持修改
			return isStart && row.id && row.taskType != 10
		}
  }
}